export enum EDatabase {
	VOICEMAIL_TONES = 'voicemailTones',
	RINGING_TONES = 'ringingTones',
}
